import YbCard from './card.vue'

export default YbCard
